import isEmpty from 'lodash/isEmpty';
import { toTimeStr } from 'utils/datetime';
import { getTargetChangedValue, getTargetOriginalValue } from '../../../../../../constants/utils';
import { getBasicLogInfo } from './utils';

const financeDueDateChangeLogTransformer = (origin) => {
  const oldDate = getTargetOriginalValue(origin, 'financeDueDate');
  const newDate = getTargetChangedValue(origin, 'financeDueDate');
  let content;
  if (!isEmpty(oldDate) && isEmpty(newDate)) {
    content = 'Finance due date has been deleted';
  } else if (isEmpty(oldDate) && !isEmpty(newDate)) {
    content = `Finance due date set to ${toTimeStr(newDate)}`;
  } else {
    content = `Finance due date changed to ${toTimeStr(newDate)}`;
  }

  return {
    ...getBasicLogInfo(origin),
    content,
  };
};

export default financeDueDateChangeLogTransformer;
